import React, { useEffect, useRef } from "react";

const TextRollup = ({ 
  items = [], 
  hold = 2500,   // pause in center (ms)
  move = 600,    // move duration (ms)
  lineHeight = "2.5rem", 
  className = "" 
}) => {
  const innerRef = useRef(null);

  useEffect(() => {
    if (!innerRef.current || items.length === 0) return;

    const n = items.length;
    const inner = innerRef.current;

    // duplicate first child for smooth looping
    const children = Array.from(inner.children);
    if (children.length === n) {
      inner.appendChild(children[0].cloneNode(true));
    }

    const itemHeight =
      inner.children[0].getBoundingClientRect().height ||
      parseFloat(getComputedStyle(inner.children[0]).height) ||
      40;

    const slot = hold + move;
    const totalMs = slot * n;

    function pct(x) {
      return (x * 100).toFixed(6) + "%";
    }

    const frames = [];
    for (let i = 0; i < n; i++) {
      const t0 = (i * slot) / totalMs;
      const th = (i * slot + hold) / totalMs;
      const tm = (i * slot + hold + move) / totalMs;
      const yStart = -i * itemHeight;
      const yNext = -(i + 1) * itemHeight;

      frames.push(
        `${pct(t0)} { transform: translateY(${yStart}px); opacity: 1; }`,
        `${pct(th)} { transform: translateY(${yStart}px); opacity: 1; }`,
        `${pct(tm)} { transform: translateY(${yNext}px); opacity: 1; }`
      );
    }
    frames.push(
      `100% { transform: translateY(${-n * itemHeight}px); opacity: 1; }`
    );

    const keyframeName = "rollup-" + Math.random().toString(36).slice(2, 9);
    const keyframesRule = `@keyframes ${keyframeName} {\n${frames.join("\n")}\n}`;

    const styleEl = document.createElement("style");
    styleEl.textContent = keyframesRule;
    document.head.appendChild(styleEl);

    inner.style.animation = `${keyframeName} ${totalMs}ms infinite ease-in-out`;

    return () => {
      document.head.removeChild(styleEl);
    };
  }, [items, hold, move]);

  return (
    <div
      className={className}
      style={{
        position: "relative",
        height: lineHeight,
        lineHeight,
        overflow: "hidden",
        maskImage: "linear-gradient(to bottom, transparent, black 20%, black 80%, transparent)",
        WebkitMaskImage: "linear-gradient(to bottom, transparent, black 20%, black 80%, transparent)",
      }}
    >
      <div ref={innerRef}>
        {items.map((text, i) => (
          <div
            key={i}
            style={{
              height: lineHeight,
              lineHeight,
              textAlign: "center",
            }}
          >
            {text}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TextRollup;
